import React, { useEffect, useMemo, useCallback, useState } from "react";
import { Header } from '../../Components/Layout/Header.jsx';
import { ObavijestiCasino } from '../../Components/Layout/ObavijestiCasino.jsx';
import { MetaTags } from '../../Components/Layout/MetaTags.jsx';

export function PopisIgara(props) {
    const [gamesList, setGamesList] = useState(null);

    useEffect(() => {
        window.scrollTo(0, 0);
        props.showMenuFn(false);

        const dataPromise = casino.utils.makeCancelablePromise(
            casino.repos.gamesListRepo.list()
        );

        dataPromise.promise.then(
            (data) => {
                setGamesList(data);
                props.showLoadingFn(false);
            },
            () => { }
        );

        return () => {
            dataPromise.cancel?.();
        };
    }, []);

    const gameUrl = useCallback((x) => {
        return `https://mcasino.supersport.hr/game/${x.brandNormaliziran}/${x.urlName}`;
    }, []);

    const pokerPravilaUrl = "https://mcasino.supersport.hr/pravila/opca-pravila?vrsta=poker"; 

    const playPoker = (e) => {
        e.preventDefault();
        casino.repos.pokerUrlRepo.get().then((res) => {
            window.location.href = res.url;
        });
    }


    const { automati, stolne, poker } = useMemo(() => {
        const result = {
            automati: [],
            stolne: [],
            poker: []
        };

        (gamesList || []).forEach((x) => {
            if (!x.vrstaIgra) return;

            const vrsta = x.vrstaIgra.toLowerCase();

            if (vrsta === "automat" || vrsta === "slot") {
                result.automati.push(x);
            } else if (vrsta === "stol" || vrsta === "table") {
                result.stolne.push(x);
            }
        });

        result.poker.push({
            name: "Texas hold’em",
            vrstaIgra: "poker",
            help: pokerPravilaUrl,
        });

        return result;
    }, [gamesList]);



    const renderTabela = useCallback((title, titleInfoUrl, items) => {
        return (
            <>
                <h2 className="popis-header-title">{title}
                    <a href={titleInfoUrl} target="_self" rel="noreferrer">
                        <span className="info" />
                    </a>
                </h2>

                <table className="casino-popis-igara">
                    <thead>
                        <tr className="table-head">
                            <td className="redni-broj">#</td>
                            <td className="vrsta">Naziv</td>
                            {items.some(x => x.vrstaIgra !== 'poker') && <td className="bonus">Bonus</td>}
                            <td className="informacije">Info</td>
                        </tr>
                    </thead>

                    <tbody>
                        {(items || []).map((x, idx) => {
                            const url = gameUrl(x);
                            const postotak = (x.promocijaPostotakNeodigrano || 0) * 100;
                            const infoUrl = x.seoInfo || x.help;

                            return (
                                <tr key={x.sifra || x.urlName}>
                                    <td className="broj">{idx + 1}.</td>

                                    <td>
                                        {x.vrstaIgra != 'poker' && <a
                                            className="ime-igre"
                                            href={url}
                                            target="_self"
                                            rel="noreferrer"
                                        >
                                            {x.name}
                                        </a>}

                                        {x.vrstaIgra == 'poker' && <a
                                            className="ime-igre"
                                            href="#!"
                                            onClick={(e) => playPoker(e)}>
                                            {x.name}
                                        </a>}
                                    </td>

                                    {x.vrstaIgra != 'poker' && <td>
                                        <p className="postotak">{postotak}%</p>
                                        {x.vrstaIgra != 'poker' && <p className="pravila-u-igri">Pravila su u igri</p>}
                                    </td>}

                                    <td className="informacije">
                                        <a href={infoUrl} target="_self" rel="noreferrer">
                                            <span className="info" />
                                        </a>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </>
        );
    }, [gameUrl]);

    return (
        <div>
            <MetaTags
                title="Popis online casino igara | SuperSport Casino | SuperCasino"
                description="Popis najpopularnijih casino igara na jednom mjestu. Zaigraj najbolje casino igre u SuperSport casinu. SuperCasino"
            />

            <Header {...props} />

            <div className="banner">
                <section className="popis-igara banner--inner selected">
                    <div className="banner--content">
                        <div className="banner--bg-container">
                            <div className="banner--repeater" />
                            <div className="banner--background" />
                        </div>
                        <div className="banner--foreground" />
                    </div>
                </section>
            </div>

            <div className="white-background">
                <div
                    id="page-wrapper"
                    className="max-width-70 margin-top-55 margin-1p-on-tablet"
                >
                    {automati && renderTabela("Igre na automatima", "https://mcasino.supersport.hr/pravila/opca-pravila?vrsta=automati", automati)}
                    {stolne && renderTabela("Igre na stolovima", "https://mcasino.supersport.hr/pravila/opca-pravila?vrsta=stolovi", stolne)}
                    {poker && renderTabela("Poker", pokerPravilaUrl, poker)}
                </div>
            </div>

            <ObavijestiCasino {...props} />
        </div>
    );
}
